export default __webpack_public_path__ + "static/media/job_svg_two.50e651c6.svg";